import React, { Component } from 'react';
import FakeData from '.././fake-data';

class FooterUI extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: (typeof FakeData.getData("yoo") === 'object') ? FakeData.getData("yoo") : {}
    }

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.getData = setInterval(this.getData, 1000)
  }

  componentWillUnmount(){
    this._isMounted = false;
  }

  getData() {
    if(!this._isMounted){
      return;
    }
    this.setState({ user: (typeof FakeData.getData("yoo") === 'object') ? FakeData.getData("yoo") : {} });
  }

  render() {
    
    return (
      <div style={{ marginTop: "300px" }}>
        {this.is &&
          <div className="row row_zero_margin home_footer">
            <div className="container clear_margins">
              <div className="col-lg-4">
                <div className="footer_widget_inner text_left">
                  <a href=""><img src="images/supotsu_logo.svg" className="footer_logo" alt="Supotsu" /></a>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer_widget_inner">
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer_widget_inner text_right">
                  © Supotsu 2017
                </div>
              </div>
            </div>
          </div>
        }
        <div className="friends_online">
          {(this.state.user.online && this.state.user.online.length > 0) &&
            <div className="friends_online_inner">
              {
                this.state.user.online.map((item, i) => {
                  return (
                    <div className="bottom_menu_avatar" key={i} onClick={() => {
                      if (FakeData.isMounted("chatApp")) {
                        if (item.conversation === null) {
                          FakeData.shared("chatApp").onUserSelect(item)
                        } else {
                          FakeData.shared("chatApp").getChatById(item.conversation.id, item.conversation.otherUser)
                        }
                        return
                      }
                      FakeData.shared("mainThread").addToChats(item.conversation)
                    }}>
                      {(item.conversation !== null && item.conversation.unread > 0) &&
                        <div className="friend_activity">{item.conversation.unread}</div>
                      }
                      <img src={item.image} alt="My Avatar" />
                    </div>
                  )
                })
              }
              <div className="bottom_menu">
                {this.state.user.online.length} Friends Online
              </div>
            </div>
          }
        </div>
        <div className="footer"></div>
      </div>
    );
  }
}

export default FooterUI;



// WEBPACK FOOTER //
// ./src/components/FooterUI.js